const CLOUD_NAME = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME as
  | string
  | undefined;
const UPLOAD_PRESET = import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET as
  | string
  | undefined;

export const cloudinaryConfigured = Boolean(CLOUD_NAME && UPLOAD_PRESET);

export type CloudinaryUpload = {
  url: string;
  publicId: string;
  width: number;
  height: number;
};

/**
 * Upload a single image straight to Cloudinary using an unsigned preset.
 * Bytes never touch our API. Returns the secure_url on success.
 */
export async function uploadImage(file: File): Promise<CloudinaryUpload> {
  if (!CLOUD_NAME || !UPLOAD_PRESET) {
    throw new Error("Photo uploads aren't configured.");
  }
  const body = new FormData();
  body.append("file", file);
  body.append("upload_preset", UPLOAD_PRESET);

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
    { method: "POST", body },
  );
  if (!res.ok) {
    let message = "Upload failed.";
    try {
      const errBody = (await res.json()) as { error?: { message?: string } };
      if (errBody.error?.message) message = errBody.error.message;
    } catch {
      // ignore
    }
    throw new Error(message);
  }
  const data = (await res.json()) as {
    secure_url: string;
    public_id: string;
    width: number;
    height: number;
  };
  return {
    url: data.secure_url,
    publicId: data.public_id,
    width: data.width,
    height: data.height,
  };
}
